import { MapState } from "./types";

export const mapStateInit: MapState = {
  error: null,
  data: null,
  items: null,
};
export default mapStateInit;
